<template>
	<Transition name="fade">
		<div :class="['tooltip', hasVariation]" ref="tooltip" v-show="display">
			<span class="tooltip__content">
				<slot />
				{{ text }}
			</span>

			<span class="tooltip__action" v-if="$slots.action">
				<slot name="action" />
			</span>

			<PopperPosition
				:trackedRefName="trackedRef"
				:popoverRefName="$refs.tooltip"
				:placement="position"
				:popperVisible="display"
				:offset="offset"
				strategy="fixed"
			/>
		</div>
	</Transition>
</template>

<script>
import componentPositionMixin from '@/mixins/component-position-mixin';
import PopperPosition from '@/components/visual/popper-position';

export default {
	name: 'Tooltip',
	components: {
		PopperPosition
	},
	props: {
		variation: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		}
	},
	mixins: [componentPositionMixin],
	computed: {
		hasVariation() {
			return this.variation
				? `tooltip--${this.variation}`
				: this.variation;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Custom Tooltip
    * Can use SCSS variables = TRUE
*/

@include transition-fade;

.tooltip {
	max-width: 450px;
	background: $tooltip-bkgd;
	padding: $padding-sm;
	border-radius: $tooltip-border-radius;
	width: max-content;
	word-break: break-word;
	font-size: $tooltip-font-size;
	font-weight: $default-font-weight;
	font-family: $font-family;
	line-height: 1;
	color: $tooltip-color;

	&--success {
		background-color: $ui-positive-light;
		border: 2px solid $ui-positive;
		@include text-contrast($ui-positive-light, $white, $black);
	}

	&--warning {
		background-color: $ui-warning-light;
		border: 2px solid $ui-warning;
		@include text-contrast($ui-warning-light, $white, $black);
	}

	&--error {
		background-color: $ui-negative-light;
		border: 2px solid $ui-negative;
		@include text-contrast($ui-negative-light, $white, $black);
	}
}
</style>
